var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageSpanishIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M575.5-308.5q-24.44 0-40.97-16.53Q518-341.56 518-366v-11h25.5v11q0 14 9 23t23 9H686q14 0 23-9t9-23v-69.5q0-13.5-9-22.75t-23-9.25H575.5q-24.44 0-40.97-16.27Q518-500.03 518-525v-69.5q0-24.44 16.53-40.97Q551.06-652 575.5-652H686q24.44 0 40.97 16.53 16.53 16.53 16.53 40.97v8H718v-8q0-13.5-9-22.75t-23-9.25H575.5q-14 0-23 9.25t-9 22.75v69.5q0 14 9 23t23 9H686q24.44 0 40.97 16.53 16.53 16.53 16.53 40.97v69.5q0 24.44-16.53 40.97Q710.44-308.5 686-308.5H575.5ZM216.5-652h223v25.5H242V-493h157.5v25.5H242V-334h197.5v25.5h-223V-652Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageSpanishIcon);
export default __webpack_public_path__ + "static/media/LanguageSpanishIcon.0102e4dda02f8b3ad3af9f87e1d3327b.svg";
export { ForwardRef as ReactComponent };